import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import StarRatings from 'react-star-ratings';
import './ConsultantTalentCard.scss';
import { analyticsTrack } from '../../../analyticsUtils';
var DEFAULT_NUM = 2;

// Taken from ConsultantSearchCard.jsx
var renderField = function renderField(attribute, icon, answer) {
  return /*#__PURE__*/React.createElement("span", {
    className: "".concat(attribute, " body-text-2 normal-weight me-3")
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas ".concat(icon, " me-2")
  }), answer);
};
var renderProject = function renderProject(project) {
  return /*#__PURE__*/React.createElement("div", {
    className: "g-row g-row--start-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-column"
  }, /*#__PURE__*/React.createElement("a", {
    href: project.show_path,
    target: "_blank",
    className: "normal-weight body-text-2",
    rel: "noreferrer"
  }, project.project_name)), project.pending_review && /*#__PURE__*/React.createElement("div", {
    className: "g-column"
  }, /*#__PURE__*/React.createElement("a", {
    href: project.review_path,
    target: "_blank",
    className: "normal-weight body-text-2 green",
    rel: "noreferrer"
  }, "Review")));
};
var ConsultantTalentCard = /*#__PURE__*/function (_Component) {
  function ConsultantTalentCard(props) {
    var _this;
    _classCallCheck(this, ConsultantTalentCard);
    _this = _callSuper(this, ConsultantTalentCard, [props]);
    _this.state = {
      currentlyViewingMore: false,
      projectsToDisplay: props.consultant.projects.slice(0, DEFAULT_NUM),
      consultant: props.consultant,
      projects: props.consultant.projects
    };
    _this.toggleViewMore = _this.toggleViewMore.bind(_this);
    return _this;
  }
  _inherits(ConsultantTalentCard, _Component);
  return _createClass(ConsultantTalentCard, [{
    key: "toggleViewMore",
    value: function toggleViewMore() {
      var _this$state = this.state,
        currentlyViewingMore = _this$state.currentlyViewingMore,
        projects = _this$state.projects;
      this.setState({
        currentlyViewingMore: !currentlyViewingMore,
        projectsToDisplay: !currentlyViewingMore ? projects : projects.slice(0, DEFAULT_NUM)
      });
    }
  }, {
    key: "renderHireAgainCTA",
    value: function renderHireAgainCTA() {
      var _this$state2 = this.state,
        consultant = _this$state2.consultant,
        projects = _this$state2.projects;
      return /*#__PURE__*/React.createElement("a", {
        className: "btn btn-primary",
        target: "_blank",
        href: consultant.consultant_hire_again_path,
        onClick: function onClick() {
          analyticsTrack('Consultant hired again', {
            location: 'My Talent Page',
            consultant: consultant.name
          });
        },
        rel: "noreferrer"
      }, "".concat(projects.length ? 'Hire Again' : 'View Profile'));
    }
  }, {
    key: "renderConsultantInfo",
    value: function renderConsultantInfo() {
      var consultant = this.props.consultant;
      return /*#__PURE__*/React.createElement("div", {
        className: "consultant-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row g-row--start-between"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-column"
      }, /*#__PURE__*/React.createElement("div", {
        className: "name-and-rating medium-demibold body-text-2 mb-4"
      }, /*#__PURE__*/React.createElement("a", {
        className: "me-2",
        target: "_blank",
        href: consultant.consultant_show_path,
        rel: "noreferrer"
      }, consultant.consultant_name), consultant.rating_avg && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(StarRatings, {
        rating: consultant.rating_avg,
        isSelectable: false,
        starRatedColor: "#EDA318",
        starHoverColor: "#EDA318",
        starDimension: "14px",
        starSpacing: "2px",
        numberOfStars: 5,
        name: "rating"
      }), /*#__PURE__*/React.createElement("span", {
        className: "ms-2"
      }, consultant.rating_avg.toFixed(1)))), /*#__PURE__*/React.createElement("div", {
        className: "roles body-text-2 normal-weight"
      }, consultant.roles && consultant.roles.join('  |  ')), /*#__PURE__*/React.createElement("div", {
        className: "years-and-levels mt-3"
      }, consultant.years_experience && renderField('years-experience', 'fa-certificate', "".concat(consultant.years_experience, " years of experience")), consultant.seniority_levels && consultant.seniority_levels.length > 0 && renderField('seniority-levels', 'fa-id-card-alt', consultant.seniority_levels.join(', ')))), /*#__PURE__*/React.createElement("div", {
        className: "g-column ms-3"
      }, this.renderHireAgainCTA())));
    }
  }, {
    key: "renderViewMore",
    value: function renderViewMore() {
      var currentlyViewingMore = this.state.currentlyViewingMore;
      var consultant = this.props.consultant;
      if (consultant.projects.length <= DEFAULT_NUM) {
        return null;
      }
      return /*#__PURE__*/React.createElement("a", {
        onClick: this.toggleViewMore,
        role: "button",
        tabIndex: "-1",
        className: "body-text-2 medium-weight"
      }, currentlyViewingMore ? 'View less' : 'View all');
    }
  }, {
    key: "renderProjectsInfo",
    value: function renderProjectsInfo() {
      var projectsToDisplay = this.state.projectsToDisplay;
      if (projectsToDisplay.length === 0) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "projects-info mt-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header medium-weight body-text-2"
      }, "Projects with you"), /*#__PURE__*/React.createElement("div", {
        className: "projects-table my-3"
      }, projectsToDisplay.map(function (project, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: project.project_id,
          id: "project-".concat(project.project_id)
        }, index > 0 && /*#__PURE__*/React.createElement("hr", {
          className: "mt-4 mb-4"
        }), renderProject(project));
      })), this.renderViewMore());
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "mb-3 consultant-talent-card"
      }, this.renderConsultantInfo(), /*#__PURE__*/React.createElement("hr", {
        className: "ignore-padding"
      }), this.renderProjectsInfo());
    }
  }]);
}(Component);
ConsultantTalentCard.propTypes = {
  consultant: PropTypes.shape({}).isRequired
};
export default ConsultantTalentCard;